module.exports = __webpack_public_path__ + "static/img/guide2.7c54b96a.png";